import React from "react";
import Button from "components/Button";
import { useMutation } from "@tanstack/react-query";
import { login } from "api/services/auth";
import { setUser } from "store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import useCountdown from "hooks/useCountdown";
import AuthLayout from "layouts/AuthLayout";
import InputField from "components/FormFields/InputField";
import Link from "components/Link";
import Alert from "components/Alert";

export default function Login() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const submitCountdown = useCountdown({
    autoStart: false,
    seconds: 3,
  });

  const loginMutation = useMutation({
    mutationFn: login,
    onMutate: () => {
      submitCountdown.reset();
    },
    onSuccess: ({ data }) => {
      dispatch(setUser(data.user));
      localStorage.setItem("authToken", data.jwt);
      localStorage.setItem("user", JSON.stringify(data.user));
    },
    onSettled: () => {
      submitCountdown.start();
    },
  });

  if (user.id != null && user.confirmed) {
    return <Navigate to="/" />;
  }

  const isValidationError =
    loginMutation.isError &&
    loginMutation.error?.response?.data?.error?.name == "ValidationError";

  const isConfirmationError =
    loginMutation.isError &&
    loginMutation.error?.response?.data?.error?.details?.notConfirmed;

  return (
    <AuthLayout>
      <h1 className="text-2xl font-semibold ">Sistemə giriş</h1>
      <form
        className="mt-8 "
        onSubmit={(e) => {
          e.preventDefault();
          if (submitCountdown.isRunning) return;

          loginMutation.mutate({
            identifier: e.target.email.value,
            password: e.target.password.value,
          });
        }}
      >
        <InputField
          name="email"
          placeholder="E-mail addressini daxil edin"
          id="email"
          label="E-mail"
          className="flex-grow"
          required
        />

        <InputField
          name="password"
          placeholder="Şifrəni daxil edin"
          id="password"
          type="password"
          label="Şifrə"
          required
          className="flex-grow"
        />

        <Link
          className="block text-end text-sm font-normal"
          to="/forgot-password"
        >
          Şifrəni unutmusunuz?
        </Link>

        <Button
          disabled={submitCountdown.isRunning}
          isLoading={loginMutation.isLoading}
          className="mt-5 mb-2 w-full text-slate-100 fill-slate-50 relative"
          type="submit"
        >
          Daxil olun{" "}
          <span className="absolute left-5">
            {submitCountdown.isRunning > 0 && submitCountdown.seconds}
          </span>
        </Button>

        {loginMutation.isError && (
          <Alert type="error">
            {loginMutation.error?.response?.data?.error?.message}
          </Alert>
        )}
      </form>
    </AuthLayout>
  );
}
